'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaBackward = function FaBackward(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.1 3.1q0.5-0.4 0.8-0.2t0.2 0.7v32.8q0 0.6-0.2 0.7t-0.8-0.2l-15.8-15.9q-0.2-0.2-0.3-0.4v15.8q0 0.6-0.3 0.7t-0.7-0.2l-15.9-15.9q-0.4-0.4-0.4-1t0.4-1l15.9-15.9q0.4-0.4 0.7-0.2t0.3 0.7v15.8q0.1-0.2 0.3-0.4z' })
        )
    );
};

exports.default = FaBackward;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/backward.js
// module id = 1356
// module chunks = 0